<style>
  @media print {
    body {
      margin: 0;
      color: #000;
      background-color: #fff;
      font-size: 10pt;
    }

    .pres-report2 table td,
    table th {
      border-bottom: 5px double black;
      padding-left: 0px;
      padding-right: 0px;
    }

    .container {
      height: 100%;
      width: 100%;
    }

    @page {
      size: A4 landscape;
      margin: 0.5cm;
    }
    .page {
      display: block;
      /*width: 29cm;
      height: 20.6cm; */
      margin: 0 auto;
      padding: 0.3cm 0;
      box-shadow: none;
      /* 列印時移除陰影 */
      box-sizing: border-box;
    }

    .page .content {
      overflow: auto;
      outline: 0;
    }

    .page .content .block {
      border: 1px solid rgba(0, 0, 0, 0);
      padding: 0.25rem;
      cursor: default;
    }

    .page .content .block:hover {
      border: 1px solid #dee2e6;
      border-radius: 0.25rem;
    }

    .page .content .block .title {
      font-weight: bold;
    }

    .page .content .block .title {
      cursor: text;
    }
  }
</style>
<div class="a4-print-style-h" #reportContainer style="margin: 0px auto; overflow-y: auto;">
  <div class="pres-report2" style="background-color: white; height: 100%; width: 100%;">
    <div class="container" id="container">
    </div>
  </div>
</div>
